import { BRIDGE_AGETH_OPTIONS, BRIDGE_OPTIONS } from "@constants/common";
import useDappConfig from "./useDappConfig";
import { AGETH, RSETH, WAGETH, WRSETH } from "@config/contractsConfig";
import { BW_VARIANT, TBW_VARIANT } from "@components/BridgeWrap/types";
import { arbitrum, mainnet } from "viem/chains";

const useBridgeWrapConfig = (variant: TBW_VARIANT) => {
  const { swapEnabledChains, vaultEnabledChains } = useDappConfig();
  // const { vaultEnabledChains } = useDappConfig();
  const isAgETH = variant === BW_VARIANT.AGETH;
  const filteredChains = isAgETH
    ? vaultEnabledChains
    : [mainnet, arbitrum, ...swapEnabledChains];
  const config = {
    assets: [
      { id: RSETH, title: RSETH },
      { id: WRSETH, title: WRSETH },
      { id: WAGETH, title: WAGETH },
      { id: AGETH, title: AGETH },
    ],
    sourceChains: Object.values([...filteredChains]).map((chain) => {
      if (chain.name.toLowerCase().includes("manta")) {
        return {
          id: chain.id,
          title: chain.name.split(" ").slice(0, 2).join(" "),
        };
      }
      return { id: chain.id, title: chain.name };
    }),
    destinationChains: Object.values([...filteredChains]).map((chain) => {
      if (chain.name.toLowerCase().includes("manta")) {
        return {
          id: chain.id,
          title: chain.name.split(" ").slice(0, 2).join(" "),
        };
      }
      return { id: chain.id, title: chain.name };
    }),
    bridgeChains: isAgETH ? BRIDGE_AGETH_OPTIONS : BRIDGE_OPTIONS,
  };

  return {
    ...config,
  };
};

export default useBridgeWrapConfig;
